// @flow
import React from 'react';
import * as css from './Card.module.css';

type PropType = {
  children?: React.Node,
  isComviq?: boolean,
  className?: String,
};

const Card = ({ children, isComviq = false, className }: PropType) => {
  const classes = isComviq ? `${css.card} ${className}` : `${className}`;
  return <div className={classes}>{children}</div>;
};

export default React.memo(Card);
